export default "/assets/images/filter-big-sneeze-box.png?4a1b37ad06d52e812c037af20fe4ea37";